/** Brand mark (PNG; there is no vector logo yet). `ink` for canvas, `color` is the primary mark. */
export function Logo({
  variant = 'color',
  height = 34,
}: {
  variant?: 'color' | 'ink';
  height?: number;
}) {
  return (
    <img
      src={variant === 'ink' ? '/logo-ink.png' : '/logo.png'}
      alt="TripCircle"
      height={height}
      style={{ height, width: 'auto', display: 'block' }}
    />
  );
}
